require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./sheshines-11-dec-2025.json") })
        }
      }, "path---sheshines-11-dec-2025");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---sheshines-11-dec-2025!./.cache/json/sheshines-11-dec-2025.json
// module id = 1222
// module chunks = 231608221292675